import PlaidOauthRedirect from './views/unregisteredPaymentRequest/PlaidOauthRedirect.vue';
import PlaidPISOauthRedirect from './views/unregisteredPaymentRequest/PlaidPISOauthRedirect.vue';
import Index from './views/unregisteredPaymentRequest/Index.vue';
import MakePayment from './views/unregisteredPaymentRequest/MakePayment.vue';
import Status from './views/unregisteredPaymentRequest/Status.vue';

export default [
    {
        path: '/upr/plaid-oauth-redirect',
        name: 'uprOauthRedirect',
        component: PlaidOauthRedirect,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/upr/plaid-pis-oauth-redirect',
        name: 'uprPisOauthRedirect',
        component: PlaidPISOauthRedirect,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/upr/:id/accept/:hash',
        name: 'unregistered-payment-requests',
        component: Index,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/upr/:id/make-payment/:hash',
        name: 'upr-make-payment',
        component: MakePayment,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/upr/:id/status/:hash',
        name: 'upr-status',
        component: Status,
        meta: {
            requiresAuth: false,
        },
    },
];
